import { CustomPhoneInput } from "../../shared/PhoneInput";
import { URLInput } from "../../shared/URLInput";
import { CountrySelect } from "../../shared/CountrySelect";
// Import kept commented while the registration number field is hidden — restore alongside the field.
// import { CompanyRegistrationInput } from "../../shared/CompanyRegistrationInput";

interface HotelDetails {
  hotel_name: string;
  category: string;
  website: string;
  contact_phone: string;
  address: string;
  postal_code: string;
  city: string;
  country: string;
  registration_number: string;
}

interface HotelDetailsFormProps {
  hotelDetails: HotelDetails;
  setHotelDetails: (details: HotelDetails) => void;
}

export function HotelDetailsForm({
  hotelDetails,
  setHotelDetails,
}: HotelDetailsFormProps) {
  return (
    <div className="space-y-4">
      <div>
        <label className="form-label">Hotel Name</label>
        <input
          type="text"
          required
          value={hotelDetails.hotel_name}
          onChange={(e) =>
            setHotelDetails({ ...hotelDetails, hotel_name: e.target.value })
          }
          className="form-input"
        />
      </div>

      <div>
        <label className="form-label">Hotel Category</label>
        <select
          required
          value={hotelDetails.category}
          onChange={(e) =>
            setHotelDetails({ ...hotelDetails, category: e.target.value })
          }
          className="form-input"
        >
          <option value="">Select Category</option>
          <option value="1">⭐ 1 Star</option>
          <option value="2">⭐⭐ 2 Stars</option>
          <option value="3">⭐⭐⭐ 3 Stars</option>
          <option value="4">⭐⭐⭐⭐ 4 Stars</option>
          <option value="5">⭐⭐⭐⭐⭐ 5 Stars</option>
        </select>
      </div>

      <div>
        <label className="form-label">Website</label>
        <URLInput
          value={hotelDetails.website}
          onChange={(value) =>
            setHotelDetails({ ...hotelDetails, website: value })
          }
          placeholder="Enter hotel website URL"
        />
      </div>

      <div>
        <label className="form-label">Country</label>
        <CountrySelect
          value={hotelDetails.country}
          onChange={(value) =>
            setHotelDetails({ ...hotelDetails, country: value })
          }
          required
        />
      </div>

      <div>
        <label className="form-label">Phone Number</label>
        <CustomPhoneInput
          value={hotelDetails.contact_phone}
          onChange={(value) =>
            setHotelDetails({ ...hotelDetails, contact_phone: value || "" })
          }
          required
        />
      </div>

      <div>
        <label className="form-label">Address</label>
        <input
          type="text"
          required
          value={hotelDetails.address}
          onChange={(e) =>
            setHotelDetails({ ...hotelDetails, address: e.target.value })
          }
          className="form-input"
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="form-label">Postal Code</label>
          <input
            type="text"
            required
            value={hotelDetails.postal_code}
            onChange={(e) =>
              setHotelDetails({ ...hotelDetails, postal_code: e.target.value })
            }
            className="form-input"
          />
        </div>
        <div>
          <label className="form-label">City</label>
          <input
            type="text"
            required
            value={hotelDetails.city}
            onChange={(e) =>
              setHotelDetails({ ...hotelDetails, city: e.target.value })
            }
            className="form-input"
          />
        </div>
      </div>

      {/* Registration number temporarily hidden — kept here so it can be restored later.
      <CompanyRegistrationInput
        country={hotelDetails.country}
        value={hotelDetails.registration_number}
        onChange={(value) =>
          setHotelDetails({ ...hotelDetails, registration_number: value })
        }
        required
      />
      */}
    </div>
  );
}
